<!-- src/components/GlobalLoader.vue -->
<template>
  <v-overlay :value="loading" z-index="9999" opacity="0.7">
    <div class="text-center column">
      <v-progress-circular indeterminate size="150" color="primary" :width="15">
        <div class="pa-5 font-weight-bold primary--text text-center">
          Processing...
        </div>
      </v-progress-circular>
    </div>
  </v-overlay>
</template>

<script>
import { EventBus } from '@/event-bus';

export default {
  name: 'GlobalLoader',
  data: () => ({
    loading: false
  }),
  created() {
    EventBus.$on('start-loader', () => {
      this.loading = true;
    });

    EventBus.$on('stop-loader', () => {
      this.loading = false;
    });
  },
  beforeDestroy() {
    EventBus.$off('start-loader');
    EventBus.$off('stop-loader');
  }
};
</script>
